<template>
<!--    打印随货单-->
    <div>
        <div class="h-piece">
            <div class="h-formBox">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" label-width="120px">
						<div class="h-thirdColumn w-newColumn">
							<!-- <el-form-item label="交货日期">
								<el-input v-model="q.orderCode" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
							</el-form-item> -->
                            <el-form-item label="开始交货日期">
                            <el-date-picker
                                style="width: 100%;"
                                v-model="q.waybillStartDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="开始日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束交货日期">
                            <el-date-picker
                                style="width: 100%;"
                                v-model="q.waybillEndDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                            
                        <el-form-item label="sap采购订单号">
                            <el-input v-model="q.poNumber" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="物料编码">
                            <el-input v-model="q.productCode" placeholder=""></el-input>
                        </el-form-item>
                       
						</div>
                        <el-collapse-transition>
						<div v-show="isScreen">
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="送货指示书号">
                            <el-input v-model="q.deliveryCode" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="打印状态">
                            <el-select v-model="q.isPrint" placeholder="请选择">
                                <el-option v-for="item in statusList" :key="item.value"
                                    :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="入库状态">
                            <el-select v-model="q.isDelivery" placeholder="请选择">
                                <el-option v-for="item in codeList" :key="item.value"
                                    :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
							</div>
						</div>
					</el-collapse-transition>
                </el-form>
                <div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="query">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
						</div>
					</div>
            </div>
        </div>
        <div>
            <el-table :data="tableData2"
                @selection-change="handleSelectionChange"
                max-height="500"
                    style="width: 100%" >
                <el-table-column
                        type="selection"
                        width="45"
                        :label="all"
                >
                </el-table-column>
                <el-table-column
                        fixed
                        type="index"
                        label="#"
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="deliveryCode"
                        label="送货指示书号"
                        width="130"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="productCode"
                        label="物料编码"
                        width="110"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="productName"
                        label="物料描述"
                        width="110"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="waybillDate"
                        label="交货日期"
                        width="110"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                
                <el-table-column
                        prop="unit"
                        label="基本单位"
                        width="100"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="deliveryNumber"
                        label="送货数量"
                        width="230"
                        :show-overflow-tooltip="true"
                >
                <!-- <template slot-scope="scope">
                    <el-button @click="add(scope.row)">+</el-button>
                    <el-input size="small" style="width:100px" v-model="scope.row.deliveryNumber" placeholder="请输入语言编码"></el-input>
                    <el-button @click="reduce(scope.row)">-</el-button>
                </template> -->
                </el-table-column>
                <el-table-column
                        prop="poNumber"
                        label="sap采购订单号"
                        width="130"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="cgCode"
                        label="采购订单号"
                        width="120"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="poLineNumber"
                        label="采购订单行项目"
                        width="140"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="ycid"
                        label="预测单号"
                        width="120"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="factory"
                        label="工厂"
                        width="90"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        label="操作"
                        fixed="right"
                        width="310"
                >
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <!-- v-if="scope.row.statusflag!= 10" -->
                            <el-button
                                    type="text"
                                    size="mini"
                                    class="h-tableLink h-btn" @click="toPrintProductBook(scope.row)">
                                打印随货单
                            </el-button>
                            <el-button
                                    type="text"
                                    size="mini"
                                    class="h-tableLink h-btn" @click="toPrintCode(scope.row)">
                                打印条形码
                            </el-button>
                            <el-button
                                    type="text"
                                    size="mini"
                                    class="h-tableLink h-btn" @click="toExportCode(scope.row)">
                                导出条形码
                            </el-button>
                            <el-button
                                    type="text"
                                    size="mini"
                                    class="h-tableLink h-btn" @click="toDetele(scope.row)">
                                撤销
                            </el-button>
                        </div>
                    </template>
                </el-table-column>

            </el-table>

            <div class="h-tableB h-mrt30">
                
                <div class="h-pagination2">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="pageNo"
                            :page-sizes="[10,50,100,500]"
                            :page-size="q.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="q.total"
                    ></el-pagination>
                </div>
                
            </div>
        </div>
        
        <el-dialog :close-on-click-modal="false" class="new-dialog"  :visible.sync="chehuidialogFormVisible">
            <!-- dialogImg -->
            <div class="h-dialogImg ">
                <h3>选择打印规格</h3>
            </div>
            <el-form  :model="addDelivery" label-width="100px" :inline="true" size="mini" class="addDeliveryForm">
                <el-form-item label="打印规格"  label-width="100" prop="size">
                    <el-select v-model="addDelivery.size" placeholder="请选择">
                        <el-option v-for="item in sizeCodeList" :key="item.value"
                            :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="submitPrintCode">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import ss from '../../../api/SystemService'
import updownfile from '../../../utils/updownfile'
export default {
    data(){
        return{
            addDelivery:{
                size:''
            },
            // 展开折叠筛选
            isScreen:false,
            closeScreen:require("@/assets/images/pimg/closeallic.png"),
            drawScreen:require("@/assets/images/pimg/dobleArr.png"),
            all: '全部',
            multipleSelection:[],
            tableData2:[],
            pageNo:1,
            q: {
                pageSize: 10,
                pageNo: 1,
                total: 0,
                startDate:'',
                endDate:'',
                productCode:'',
                poNumber:'',
                deliveryCode:'',
                isPrint:'',
                isDelivery:'',
            },
            codeList:[
                { value: 0,label: '未入库'},
                { value: 1,label: '部分入库'},
                { value: 2,label: '已入库'},
                { value:'',label: '全部'},
            ],
            sizeCodeList:[
                { value: '80*40',label: '80*40'},
                { value: '60*40',label: '60*40'},
                { value: '40*30',label: '40*30'},
            ],
            statusList:[{ value: 0,
                    label: '已打印'},
                    { value: 1,
                    label: '未打印'},],
                chanpinzhuangtai: [{
                    value: 1,
                    label: '虚拟物料'
                }, {
                    value: 0,
                    label: '真实物料'
                }],
                //弹出层 
                chehuidialogFormVisible: false,
                //title
                title:'',
                info:[]
        }
        
    },
    mounted(){
        this.query()
    },
    methods:{
        query() {
            //查询
            console.log("ceshi");
            //selectPageInfo
            ss.chanpin.selectPageInstruction(this.q).then(res => {
                    console.log('看看走没走查询',res)
                    this.tableData2 = res.records,
                    this.q.total = res.total;
                })
        },
        resetData(){
                console.log("重置")
                this.q = {
                    materialCode:null,
                    checkStatus:null,
                    startDate:null,
                    endDate:null,
                    levelCode:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                }
                 this.query()
            },
        //打印条形码
        toPrintCode(row){
            var row = row
            console.log(row)
            this.info = row
            this.chehuidialogFormVisible = true;
        },
        
        toPrintProductBook(row){
            var id = row.id
            ss.chanpin.printProductBook(id)
            .then(res =>{
                console.log(res)
                //downloadPdf(id)

                // let blob = new Blob([res], {
                //     type: `application/pdf;charset-UTF-8` //word文档为msword,pdf文档为pdf
                // });
                // let objectUrl = URL.createObjectURL(blob);
                // let link = document.createElement("a");
                // let fname = `我的文档`; //下载文件的名字
                // link.href = objectUrl;
                // link.setAttribute("download", fname);
                // document.body.appendChild(link);
                // link.click();

                let link = document.createElement('a')
                let blob = new Blob([res],{type: 'application/pdf'});
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob);
                //link.setAttribute('download')
                link.setAttribute('download', row.deliveryCode+`随货单.pdf`)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)

                // const blob = new Blob([res], {
                //     type: 'application/pdf'
                // });
                // console.log(blob, '----------0990');
                // const fileName = '招募人才.pdf';      // 定义文件名字
                // const linkNode = document.createElement('a');   // 添加点击事件

                // linkNode.download = fileName; //a标签的download属性规定下载文件的名称
                // linkNode.style.display = 'none';
                // linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
                // document.body.appendChild(linkNode);
                // linkNode.click(); //模拟在按钮上的一次鼠标单击

                // URL.revokeObjectURL(linkNode.href); // 释放URL 对象
                // document.body.removeChild(linkNode);
            }).catch(function(error) {   
                console.log(error)
            });
        },
        submitPrintCode(){
            //
            var size = this.addDelivery.size
            if(size == ''){
                this.$message.error('请选择规格尺寸');
            }else{
                this.info.size = size
            console.log(this.info)
            ss.chanpin.printBarCode(this.info).then(res =>{

                let link = document.createElement('a')
                let blob = new Blob([res],{type: 'application/pdf'});
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob);
                //link.setAttribute('download')
                link.setAttribute('download', this.info.deliveryCode+`条形码.pdf`)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                this.chehuidialogFormVisible= false;
            })

            }
            
        },
        toExportCode(val) {
            updownfile.down("/api/swyl/v1/demo/bscAccompanyingInstruction/downloadExcel", val, "post");
        },
        toDetele(row){
            var id = row.id
            this.$msg.confirm("确认要删除该送货指示书吗?", () => {
                        var ids = {
                            id:id
                        }
                        ss.chanpin.eleteDeliverBook(ids).then(res =>{
                            console.log(res)
                            if(res.f == true){
                                this.$message({
                                    message: res.msg,
                                    type: 'success'
                                });
                                this.query()
                            }else{
                                this.$message.error(res.msg);
                            }
                        })
                    });
        },

        // 展开折叠
		collapseChange(){
            this.isScreen = !this.isScreen;
        },
        getSing(){
            console.log(this.multipleSelection)
        },
        reduce(row){

        },
        add(row){
            console.log(row)
            row.languageCode = Number(row.languageCode) + 1
        },
        cancel(){
            this.chehuidialogFormVisible = false;
        },
        // 获取所有选取的信息
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection)
            this.ids = this.multipleSelection.map(item => item.id).join()//获取所有选中行的id组成的字符串，以逗号分隔
            this.businessId= this.multipleSelection.map(item => item.businessId).join()
        },
         // 分页
        handleCurrentChange: function (pageNo) {
            console.log(pageNo)
            this.q.pageNo = pageNo; //点击第几页
            this.query()
        },

        // 每页信息数量更改
        handleSizeChange(val) {
            console.log(val)
            this.pageNo = 1
            this.q.pageSize = val
            this.query()
        },
    }
}
</script>
    <style scoped>
    .xiangmu > .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 3rem !important;
    }
    /deep/ .el-dialog__header{
        padding: 0
    }
    /deep/.el-dialog {
        border-radius: 0.1rem;
        width: 7.89rem;
    }
    /deep/ .el-dialog__body{
        padding: 0;
    }
    /deep/ .el-dialog__header{
        background: #2785E7
    }
    /deep/ .el-dialog__headerbtn .el-dialog__close{
        height: 0.56rem;
        width: 0.56rem;
        line-height: 0.56rem;
        text-align: center;
        background-color: #fff;
        color: #015ba0;
        border-radius: 100%;
        font-size: 0.34rem;
    }
    .h-dialogImg {
        height: 1.62rem;
        background: url(/img/h-dialogImg.471fa846.png) center no-repeat;
        background-size: 7.89rem;
        padding-left: 4.02rem;
    }
    .h-dialogImg h3{
        text-align: left;
        padding:.6rem 0 0 0;
        font-size: 0.3rem;
        color: #fff;
        font-weight: normal;
        letter-spacing: 0.02rem;
    }
    .addDeliveryForm{
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .addDeliveryForm /deep/.el-form-item__label {
        width: 84px;
        font-size: 0.18rem;
        color: #4a4a4a;
        line-height: 0.28rem;
        vertical-align: top;
        padding-right: 5px;
        letter-spacing: 0;
        display:inline-block;
        text-align: right;
    }
    .addDeliveryForm /deep/.el-form-item__content .el-input__inner {
        border-radius: 0;
        background: transparent;
        color: #868686;
        border: 0;
        border-bottom: 1px solid #dedede;
        height: 0.29rem;
        line-height: 0.28rem;
        padding-left: 0.15rem;
    }

@media screen and (min-width: 1620px) and (max-width: 5000px){
.h-formBorder .el-form-item__label, .h-formbLine .el-form-item__label, .h-formBorder .el-input__inner, .el-pagination span:not([class*=suffix]), .h-pagination2 .el-pagination__sizes .el-input__inner, .el-pagination button, .h-pagination2 .el-pager li, .h-pagination2 .el-pagination .el-pagination__jump, .h-btn.el-button, .el-input__inner, .el-radio__label, .el-checkbox__label, .cesuantitles, .el-textarea__inner, .el-switch__label span, .s-row {
    font-size:0.12rem;
}
}


    </style>